// BFF: ● practice_hours — bffCrmPracticeHours.
export { default } from './PracticeHoursSettings'
